<template>
  <div id="app">
    <header class="header" v-if="data">
      <Header :isProductPage="isProductPage" :headData="data" />
    </header>
    <main class="main">
      <router-view @set-product-page="handleProductPage"></router-view>
    </main>
    <footer class="footer" v-if="data">
      <Footer :headData="data" />
    </footer>
  </div>
</template>

<script>
import Home from "@/views/Home";

import Header from "@/components/Header";
import Footer from "@/components/Footer";

import { getAllMainCategoriesWithSubAndProducts } from "@/api/productAPI";
export default {
  components: {
    Home,
    Header,
    Footer,
  },
  data() {
    return {
      isProductPage: false,
      data: null,
    };
  },
  async created() {
    this.data = await getAllMainCategoriesWithSubAndProducts();
  },
  methods: {
    handleProductPage(isProduct) {
      this.isProductPage = isProduct;
    },
  },
};
</script>

<style lang="less" scoped></style>
